'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const designSystem = require('@zapier/design-system');
const SelectBase_SelectContext = require('../SelectBase/SelectContext.cjs.js');

const selectItem = "_select-item_hksyq_1";
const styles = {
	selectItem: selectItem
};

const SelectItem = (_a) => {
  var { children, className, isDisabled = false, iconName, size, textValue, value } = _a, props = tslib_es6.__rest(_a, ["children", "className", "isDisabled", "iconName", "size", "textValue", "value"]);
  const { registerDisabledItem, size: sizeFromContext } = SelectBase_SelectContext.useSelectContext();
  React.useEffect(() => {
    if (isDisabled) {
      registerDisabledItem(value || "");
    }
  }, [isDisabled, value, registerDisabledItem]);
  return jsxRuntime.jsx(reactAriaComponents.ListBoxItem, Object.assign({ className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.selectItem, className], renderProps), "data-size": size !== null && size !== void 0 ? size : sizeFromContext, "data-zds": true, id: value, textValue }, props, { children: (renderProps) => jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [iconName && jsxRuntime.jsx(designSystem.Icon, { name: iconName, size: 16 }), typeof children === "function" ? children(renderProps) : children] }) }));
};

exports.SelectItem = SelectItem;
//# sourceMappingURL=SelectItem.cjs.js.map
